import * as React from 'react';

import * as style from './NewReviewModalRating.css';

export const NewReviewModalRating: React.FC<React.PropsWithChildren> = props => {
  const { children } = props;

  return <div className={style['container']}>{children}</div>;
};
